<div class="overlay filterData filterDataControls">

  <div class="overlay-header">
    <h3>Filters</h3>
    <div class="close-btn">
      <button mat-icon-button mat-dialog-close>
        <f-icon [iconConfig]="iconConfig"></f-icon>
      </button>
    </div>
  </div>
  <div class="section-divider"></div>
  <form id="filterForm" class="form-scroll">
    <div class="overlay-body">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h3>Date Range</h3>
          </div>
        </div>
        <div class="row border-bottom" [formGroup]="range">
          <div class="col-md-6 flex">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Date From (MMM-DD-YYYY)</mat-label>
              <input matInput [matDatepicker]="picker1" [max]="maxDate" formControlName="start"
                (dateChange)="addEvent( $event)">
              <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Date To (MMM-DD-YYYY)</mat-label>
              <input matInput [matDatepicker]="picker2" [min]="minDate" [max]="maxDate" formControlName="end">
              <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <!-- <p>{{range.value | json}}</p> -->
        </div>
        <div class="row">
          <div class="col-md-12">
            <!-- Angular autocomplete Chips -->
            <h3>Agent <span> (Max. 3 agents per search)</span> </h3>
            <mat-form-field appearance="fill" class="component-box chips">
              <mat-label>Type agent's name here e.g., Michaelangelo A</mat-label>
              <mat-chip-list #chipList aria-label="Agent selection">
                <mat-chip *ngFor="let agent of selectedAgents" (removed)="remove(agent)">
                  {{agent}}
                  <button matChipRemove>
                    <f-icon [iconConfig]="iconConfig"></f-icon>
                  </button>
                </mat-chip>
                <input placeholder="" #AgentInput [formControl]="AgentValue" [matAutocomplete]="auto"
                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add($event)">
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                <mat-option *ngFor="let agent of filteredAgent | async" [value]="agent">
                  {{agent}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <!-- p tag  added by amarjeet -->
            <p class="error" *ngIf="isMaxAgents">Only 3 agents can be selected.</p>
          </div>

        </div>
        <!-- Commenting out the Topic Autochip component, and should be uncommented by Features when in use. -->
        <div class="row section-divider "></div>
        <div class="row">
          <div class="col-md-12">

            <h3>Topic <span> (Max. 3 topics per search)</span> </h3>
            <mat-form-field appearance="fill" class="component-box chips">
              <mat-label>Type topics here. e.g., Health related</mat-label>
              <mat-chip-list #chipList2 aria-label="Topic selection">
                <mat-chip *ngFor="let topic of selectedTopics" (removed)="removeTopic(topic)">
                  {{topic}}
                  <button matChipRemove>
                    <f-icon [iconConfig]="iconConfig"></f-icon>
                  </button>
                </mat-chip>

                <input placeholder="" #topicInput [formControl]="topicValue" [matAutocomplete]="auto2"
                  [matChipInputFor]="chipList2" (matChipInputTokenEnd)="addTopic($event)">
              </mat-chip-list>
              <mat-autocomplete #auto2="matAutocomplete" (optionSelected)="selectedTopic($event)">
                <mat-option *ngFor="let topic of filteredTopic | async" [value]="topic" class="truncate">
                  {{topic}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <p class="error" *ngIf="isMaxTopics">Only 3 topics can be selected.</p>
          </div>
        </div>
        <div class="section-divider"></div>
        <div class="row channel-list">
          <div class="col-md-12" id="">
            <h3>Domain</h3>
            <ng-container *ngFor="let domain of rootScope.filterDomainListData">
              <mat-checkbox class="" #domainLists name="{{domain}}"
                (change)="domainList($event, domain)">{{domain}}</mat-checkbox>
            </ng-container>

          </div>
        </div>
        <div class="row section-divider"></div>
        <div class="row channel-list">
          <div class="col-md-12" id="">
            <h3>Channel</h3>
            <ng-container *ngFor="let channel of rootScope.IHChannelList; index as i; ">
              <mat-checkbox class="" #channelLists name="{{channel.fieldValue}}"
                (change)="channelList($event, channel.fieldValue)">{{channel.fieldValueDescription}}</mat-checkbox>
            </ng-container>


          </div>
        </div>
        <div class="row section-divider"></div>
      </div>
    </div>
  </form>
  <div class="button-controls">

    <f-button text="Clear all" type="button" variant="action" (click)="clearAll()"></f-button>
    <f-button text="Apply" type="button" variant="progressive"
      [disabled]="(!range.value.start && !range.value.end && selectedChannels.length == 0 && selectedAgents.length == 0 &&  selectedTopics.length == 0 && selectedDomains.length == 0 && !intHistService.IHListViewDataCAMap[rootScope.activeCustTab.customerSessionId]?.isFilterApplied) || (range.invalid && range.dirty)"
      [ngClass]="{disableBtn:(!range.value.start && !range.value.end && selectedChannels.length == 0 && selectedAgents.length == 0 && selectedTopics.length == 0 && selectedDomains.length == 0 && !intHistService.IHListViewDataCAMap[rootScope.activeCustTab.customerSessionId]?.isFilterApplied) || (range.invalid && range.dirty)}"
      (click)="apply()"></f-button>
  </div>



</div>